<template>
    <div v-if="$user" class="x-navbar-detailed-user" style="display: flex; width: 100%;">
        <user-avatar></user-avatar>
        <div style="display: flex; align-items: center; width: 100%; margin-left: 8px">
            <div style="width: 100%">
                <div>
                    {{ $user.name }}
                </div>
                <div v-if="$user.typeInfo" style="color: #6b8585">
                    {{ $user.typeInfo.name }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    const UserAvatar = require('./UserAvatar.vue')

    export default {
        components: {
            UserAvatar
        },
        data () {
            return {}
        }
    }
</script>


// WEBPACK FOOTER //
// DetailedUser.vue?33d35fdb